import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';

// The API sends "YYYY-MM-DD", or "YYYY-MM" for long periods grouped by month.
const formatPoint = (value) => {
    const isMonth = value.length === 7;
    const date = new Date(`${isMonth ? `${value}-01` : value}T00:00:00`);
    return date.toLocaleDateString('en-GB', isMonth ? { month: 'short', year: 'numeric' } : { day: 'numeric', month: 'short' });
};

const VenueTrendChart = ({ title, seriesName, unit, color = '#0789d5', data = [], loading = false }) => {
    const series = useMemo(() => [{ name: seriesName, data: data.map((row) => row.count) }], [data, seriesName]);
    const options = useMemo(() => ({
        chart: { type: 'area', height: 280, toolbar: { show: false }, zoom: { enabled: false } },
        colors: [color],
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2 },
        fill: { type: 'gradient', gradient: { opacityFrom: 0.3, opacityTo: 0.02 } },
        grid: { borderColor: '#e2e8f0', strokeDashArray: 3 },
        xaxis: {
            categories: data.map((row) => formatPoint(row.date)),
            tickAmount: 6,
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: { rotate: 0, hideOverlappingLabels: true, style: { colors: '#64748b', fontSize: '12px' } }
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
            labels: { formatter: (value) => Math.round(value).toString(), style: { colors: '#64748b', fontSize: '12px' } }
        },
        tooltip: { y: { formatter: (value) => `${value} ${value === 1 ? unit : `${unit}s`}` } }
    }), [data, color, unit]);

    return (
        <div className="hs-modern-card h-100">
            <div className="p-24">
                <h6 className="mb-1 fw-bold text-lg">{title}</h6>
                <div className="mt-16">
                    {loading ? (
                        <div className="text-center py-5 text-secondary-light">Loading...</div>
                    ) : (
                        <ReactApexChart options={options} series={series} type="area" height={280} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default VenueTrendChart;
